import { GTM_ID } from '../../configurations/gtm';
import { useCurrentSite } from '../providers/currentSite/useCurrentSite';

export function useGtmConfig() {
    const { currentSite } = useCurrentSite();

    return {
        id: GTM_ID,
        serverHost: currentSite.gtmServer.host,
    };
}
